export const RETAIL_NAICS_CODES = [
  '441110',
  '441120',
  '441210',
  '441222',
  '441228',
  '441310',
  '441320',
  '442110',
  '4422',
  '442210',
  '442291',
  '442299',
  '4431',
  '443141',
  '443142',
  '4441',
  '444110',
  '444120',
  '444130',
  '444190',
  '4442',
  '444210',
  '444220',
  '445110',
  '445120',
  '445210',
  '445220',
  '445230',
  '445291',
  '445292',
  '445299',
  '445310',
  '446110',
  '446120',
  '446130',
  '446191',
  '446199',
  '447110',
  '447190',
  '4481',
  '448110',
  '448120',
  '448130',
  '448140',
  '448150',
  '448190',
  '448210',
  '448310',
  '448320',
  '449210',
  '451110',
  '451120',
  '451130',
  '451140',
  '451211',
  '451212',
  '452210',
  '452311',
  '452319',
  '453110',
  '453210',
  '453220',
  '453310',
  '453910',
  '453920',
  '453991',
  '453998',
  '454110',
  '454310',
  '454390',
  '455110',
  '459410',
  '459420',
  '532111',
  '532120',
  '532210',
  '532282',
  '532284',
  '532289',
  '532310',
  '532412',
  '532490',
  '722320',
  '722410',
  '722511',
  '722513',
  '722514',
  '722515',
  '8111',
  '811111',
  '811113',
  '811118',
  '811121',
  '811122',
  '811191',
  '811192',
  '811198',
  '811211',
  '811212',
  '811219',
  '811310',
  '811411',
  '811412',
  '811420',
  '811430',
  '811490',
  '81211',
  '812111',
  '812112',
  '812113',
  '812191',
  '812199',
  '8122',
  '812210',
  '812220',
  '812310',
  '812320',
  '8129',
  '812910',
  '812921',
  '812990',
  '813110',
]

export const HOSPITALITY_NAICS_CODES = [
  '5615',
  '561510',
  '561520',
  '561591',
  '561599',
  '561920',
  '6233',
  '623311',
  '623312',
  '623990',
  '7111',
  '711110',
  '711130',
  '711190',
  '711211',
  '711212',
  '711219',
  '711310',
  '711410',
  '711510',
  '712110',
  '712120',
  '712130',
  '712190',
  '713110',
  '713120',
  '713210',
  '713290',
  '713910',
  '713920',
  '713930',
  '713940',
  '713950',
  '713990',
  '721110',
  '721120',
  '721191',
  '721199',
  '7212',
  '721211',
  '721214',
  '721310',
]

export const INDUSTRIAL_NAICS_CODES = [
  '111211',
  '111421',
  '111998',
  '112990',
  '115112',
  '115310',
  '211120',
  '212390',
  '213111',
  '213112',
  '213114',
  '221111',
  '221112',
  '221114',
  '221115',
  '221122',
  '221210',
  '221310',
  '2361',
  '236115',
  '236118',
  '237110',
  '237310',
  '238110',
  '238140',
  '238150',
  '238160',
  '238190',
  '2382',
  '238220',
  '238290',
  '2383',
  '238310',
  '238330',
  '238390',
  '2389',
  '238990',
  '311',
  '311111',
  '311119',
  '31135',
  '311351',
  '311411',
  '311412',
  '311421',
  '3116',
  '311811',
  '3119',
  '311920',
  '311991',
  '311999',
  '3121',
  '312113',
  '312120',
  '312130',
  '312140',
  '314120',
  '314999',
  '315190',
  '315240',
  '315990',
  '316210',
  '316992',
  '316998',
  '321113',
  '321211',
  '321219',
  '321992',
  '321999',
  '322121',
  '322211',
  '322230',
  '3231',
  '323111',
  '323113',
  '323117',
  '324110',
  '324122',
  '325180',
  '325510',
  '325520',
  '325620',
  '3261',
  '326199',
  '32621',
  '326211',
  '326212',
  '327110',
  '327120',
  '327212',
  '327999',
  '3311',
  '33121',
  '331221',
  '3313',
  '331313',
  '332311',
  '332313',
  '332321',
  '332322',
  '332510',
  '332613',
  '3327',
  '332722',
  '332812',
  '332992',
  '3331',
  '333111',
  '333112',
  '333120',
  '333132',
  '3333',
  '333318',
  '333413',
  '333414',
  '333415',
  '333517',
  '333612',
  '333618',
  '3339',
  '333991',
  '334310',
  '3344',
  '334413',
  '334510',
  '334511',
  '334519',
  '335220',
  '335311',
  '335312',
  '335314',
  '335999',
  '336111',
  '336120',
  '336211',
  '336214',
  '336330',
  '336350',
  '336390',
  '336411',
  '336612',
  '336991',
  '336999',
  '337121',
  '337125',
  '339112',
  '339113',
  '339114',
  '3399',
  '339910',
  '339920',
  '339930',
  '339950',
  '339991',
  '339999',
  '423110',
  '423120',
  '423130',
  '423140',
  '423210',
  '423220',
  '423310',
  '423320',
  '423330',
  '423390',
  '423420',
  '423450',
  '423510',
  '423610',
  '423620',
  '423690',
  '423710',
  '423720',
  '423730',
  '423740',
  '4238',
  '423810',
  '423820',
  '423830',
  '423840',
  '423850',
  '423860',
  '423910',
  '423920',
  '423930',
  '423940',
  '423990',
  '424210',
  '424320',
  '424340',
  '424410',
  '424430',
  '424450',
  '424490',
  '424510',
  '424690',
  '424710',
  '424720',
  '424910',
  '424950',
  '481111',
  '4821',
  '482111',
  '483',
  '483112',
  '4841',
  '484110',
  '484121',
  '484210',
  '484230',
  '485',
  '485111',
  '485113',
  '485210',
  '485310',
  '485320',
  '485410',
  '485999',
  '487',
  '487110',
  '488119',
  '488190',
  '488310',
  '488410',
  '488490',
  '488510',
  '488991',
  '491110',
  '492110',
  '493110',
  '493120',
  '493130',
  '493190',
  '5616',
  '561612',
  '561621',
  '561622',
  '5617',
  '561710',
  '561720',
  '561730',
  '561740',
  '561790',
  '561990',
  '562',
  '562119',
  '562211',
  '562212',
  '562219',
  '562910',
  '562920',
  '562991',
  '812930',
]

export const MEDICAL_NAICS_CODES = [
  '621111',
  '621112',
  '621210',
  '621310',
  '621320',
  '621330',
  '621340',
  '621399',
  '6214',
  '621410',
  '621420',
  '621492',
  '621493',
  '621498',
  '6215',
  '621511',
  '621512',
  '621610',
  '621910',
  '621991',
  '621999',
  '622110',
  '622210',
  '622310',
  '623',
  '623110',
  '623220',
]

export const OFFICE_NAICS_CODES = [
  '511120',
  '511130',
  '511191',
  '511210',
  '512110',
  '512131',
  '512132',
  '512199',
  '512240',
  '512250',
  '512550',
  '5151',
  '515120',
  '515210',
  '517312',
  '517911',
  '517919',
  '518210',
  '519110',
  '519120',
  '519130',
  '519190',
  '5221',
  '522110',
  '522120',
  '522130',
  '522291',
  '522298',
  '522310',
  '522320',
  '522390',
  '523110',
  '523120',
  '523920',
  '523930',
  '523999',
  '524113',
  '524114',
  '524126',
  '524127',
  '524128',
  '524210',
  '525110',
  '525990',
  '531130',
  '531190',
  '531210',
  '531311',
  '532299',
  '541110',
  '541120',
  '5412',
  '541200',
  '541213',
  '541219',
  '541310',
  '541330',
  '541340',
  '5414',
  '541430',
  '541519',
  '5416',
  '541611',
  '541613',
  '541614',
  '541618',
  '541690',
  '541714',
  '541715',
  '5418',
  '541810',
  '541860',
  '5419',
  '54192',
  '541921',
  '541940',
  '5511',
  '551112',
  '551114',
  '561311',
  '561320',
  '561431',
  '561440',
  '561499',
  '611110',
  '611210',
  '611310',
  '611410',
  '611420',
  '6115',
  '611511',
  '611512',
  '611519',
  '611610',
  '611620',
  '611630',
  '611691',
  '611692',
  '611699',
  '611710',
  '624',
  '6241',
  '624110',
  '624120',
  '624190',
  '624210',
  '624221',
  '624410',
  '813212',
  '813219',
  '813311',
  '813312',
  '813319',
  '813410',
  '813910',
  '813920',
  '813930',
  '813990',
  '921110',
  '921130',
  '921190',
  '9221',
  '922110',
  '922120',
  '922140',
  '922150',
  '922160',
  '922190',
  '9231',
  '923120',
  '923130',
  '923140',
  '925110',
  '9261',
  '926120',
  '928110',
  '928120',
]

export const SHOPPING_CENTER_NAICS_CODE = ['531120']

export const ALL_CATEGORY_NAICS_CODES = [
  ...RETAIL_NAICS_CODES,
  ...MEDICAL_NAICS_CODES,
  ...OFFICE_NAICS_CODES,
  ...INDUSTRIAL_NAICS_CODES,
  ...HOSPITALITY_NAICS_CODES,
  ...SHOPPING_CENTER_NAICS_CODE,
]

const MULTIFAMILY_NAICS_CODES: string[] = ['pending-multi-family']
const SINGLEFAMILY_NAICS_CODES: string[] = ['pending-single-family']

export const POI_CATEGORIES_MAP = new Map<
  | 'RETAIL'
  | 'MEDICAL'
  | 'OFFICE'
  | 'INDUSTRIAL'
  | 'HOSPITALITY'
  | 'MULTIFAMILY'
  | 'SINGLEFAMILY'
  | 'OTHER'
  | 'SHOPPING_CENTER',
  string[]
>()
POI_CATEGORIES_MAP.set('RETAIL', RETAIL_NAICS_CODES)
POI_CATEGORIES_MAP.set('MEDICAL', MEDICAL_NAICS_CODES)
POI_CATEGORIES_MAP.set('OFFICE', OFFICE_NAICS_CODES)
POI_CATEGORIES_MAP.set('INDUSTRIAL', INDUSTRIAL_NAICS_CODES)
POI_CATEGORIES_MAP.set('HOSPITALITY', HOSPITALITY_NAICS_CODES)
POI_CATEGORIES_MAP.set('MULTIFAMILY', MULTIFAMILY_NAICS_CODES)
POI_CATEGORIES_MAP.set('SINGLEFAMILY', SINGLEFAMILY_NAICS_CODES)
POI_CATEGORIES_MAP.set('SHOPPING_CENTER', SHOPPING_CENTER_NAICS_CODE)
